import * as Sentry from '@sentry/react'
import React, {useState} from 'react'
import {CircularProgress} from '../../webui/progress/CircularProgress'
import {Typography} from '../../webui/Typography'
import {useImageUrl} from './gql/useImageUrl'

interface Props {
  id: string
}

export const RentalImage: React.FC<Props> = ({id}) => {
  const {imageUrl, loading, error, createImageGetUrl} = useImageUrl(id)
  const [retried, setRetried] = useState(false)

  if (loading) return <CircularProgress />
  if (error) return <Typography>No image found</Typography>
  if (!imageUrl) return <Typography>No image found</Typography>

  const onImgError = () => {
    // Log to Sentry so we can correlate with server events
    Sentry.captureMessage('Rental image failed to load', {
      level: 'warning',
      tags: {feature: 'rental-image', rentalId: id},
      extra: {imageUrl},
    })

    if (!retried) {
      setRetried(true)
      createImageGetUrl() // Request a fresh presigned GET once
    }
  }

  // key={imageUrl} forces <img> to reload when the URL changes
  return <img key={imageUrl} src={imageUrl} alt="rental" height="100%" onError={onImgError} />
}
